'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQItemProps {
  faq: {
    question: string;
    answer: string;
    category: string;
  };
}

const FAQItem = ({ faq }: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden bg-white transition-all duration-300 hover:shadow-md hover:border-[#42AF47]/30">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left hover:bg-gray-50 transition-colors duration-200"
        aria-expanded={isOpen}
      >
        <div className="flex-1">
          <div className="inline-block px-3 py-1 bg-[#42AF47]/10 rounded-full mb-2">
            <span className="text-xs font-medium text-[#42AF47]">{faq.category}</span>
          </div>
          <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
        </div>
        <Icon 
          name="ChevronDownIcon" 
          size={24} 
          className={`text-[#42AF47] flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96' : 'max-h-0'}`}
      >
        <div className="px-6 pb-5 pt-2">
          <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
        </div>
      </div>
    </div>
  );
};

export default FAQItem;